import loadable from '@loadable/component';

const loadableComponent = loadable(() => import('../CodeHighlighterSlice'));

export default loadableComponent;
